import { render, staticRenderFns } from "./AgingCard.vue?vue&type=template&id=86e378be"
import script from "./AgingCard.vue?vue&type=script&lang=js"
export * from "./AgingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports